// extracted by mini-css-extract-plugin
module.exports = {"section":"section__1lZuA","select":"select__1qgm-"};